<template>
  <div></div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'eIndex',
  mixins: [pagePathMixin],
};
</script>

<style scoped></style>
